var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRubleSign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M328 376H80V304H232C306.984 304 368 242.984 368 168S306.984 32 232 32H104C81.938 32 64 49.938 64 72V288H8C3.578 288 0 291.578 0 296S3.578 304 8 304H64V376H8C3.578 376 0 379.578 0 384S3.578 392 8 392H64V472C64 476.422 67.578 480 72 480S80 476.422 80 472V392H328C332.422 392 336 388.422 336 384S332.422 376 328 376ZM80 72C80 58.766 90.766 48 104 48H232C298.172 48 352 101.828 352 168S298.172 288 232 288H80V72Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRubleSign);
export default __webpack_public_path__ + "static/media/ruble-sign.ef17eeca3f56f159685b04a7b22d0f82.svg";
export { ForwardRef as ReactComponent };